import React from "react";
import ThemedCardComponent from "../../../genericComponents/themedCardCompoennt";
import "./InsightsContainer.css";
import GenericChipComp from "../../../genericComponents/GenericChipComp";

function InsightsContainer({
  impact_to_account,
  accountName,
  relevance_to_seller,
  clientName,
  impact_score,
  opportunity_size,
}) {
  // Function to render content based on whether it's a string or array
  const renderContent = (content) => {
    if (Array.isArray(content)) {
      return (
        <ul className="insights-list">
          {content.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      );
    }
    return <>{content}</>;
  };

  return (
    <div className="insight-cards-container">
      <ThemedCardComponent
        title={<>Implication for {accountName}</>}
        description={
          <>
            <p>{renderContent(impact_to_account)}</p>
            <p>
              {" "}
              {impact_score && <GenericChipComp score={impact_score} />}
            </p>
          </>
        }
      />
      <ThemedCardComponent
        title={<>Relevance to {clientName}</>}
        description={




          <>
          <p>{renderContent(relevance_to_seller)}</p>
          <p>
            {" "}
            {/* <GenericChipComp otherTxt={`Opportunity Size : ${opportunity_size} `} /> */}
          </p>
        </>
        }



      />
    </div>
  );
}

export default InsightsContainer;
